import { hdmgdjScreenshots } from "@/mocks/hdmgdj/screenshots";

export default function HdmgdjScreenshots() {
  return (
    <section id="hdmgdj-shots" className="w-full bg-background-100 py-16 md:py-24">
      <div className="hdmgdj-container">
        <div className="hdmgdj-reveal flex flex-col md:flex-row md:items-end md:justify-between gap-5">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-accent-600 text-[14px] font-label font-bold">
              <i className="ri-smartphone-line text-lg" />
              APP 实拍界面
            </span>
            <h2 className="mt-3 font-heading text-foreground-950 text-[30px] md:text-[44px] leading-tight">
              五块屏幕，看全整个
              <span className="text-accent-600"> 魔改世界</span>
            </h2>
          </div>
          <p className="text-[15px] leading-7 text-foreground-600 md:max-w-sm">
            从首页推荐到沉浸追剧，从催更互动到心愿榜单，每一处交互都为看剧而生；安装后即可获得同样清爽的体验。
          </p>
        </div>

        <div className="mt-12 md:mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-x-4 gap-y-10 md:gap-x-5">
          {hdmgdjScreenshots.map((shot, index) => (
            <div
              key={shot.id}
              className={`hdmgdj-reveal ${index % 2 === 1 ? "lg:mt-14" : ""}`}
              style={{ transitionDelay: `${(index % 5) * 60}ms` }}
            >
              <figure>
                <div className="flex items-center gap-2 mb-3">
                  <span className="font-heading text-[15px] text-accent-600">{shot.index}</span>
                  <span className="h-px flex-1 bg-background-300" />
                  <span className="text-[11px] font-label text-foreground-500">{shot.tag}</span>
                </div>
                <div className="hdmgdj-phone hdmgdj-phone-light">
                  <img
                    src={shot.image}
                    alt={`黄豆魔改短剧${shot.title}界面截图`}
                    title={`黄豆魔改短剧-${shot.title}`}
                    className="w-full h-auto"
                  />
                </div>
                <figcaption className="mt-3.5">
                  <p className="text-[15px] font-bold font-label text-foreground-950">{shot.title}</p>
                  <p className="mt-1.5 text-[13px] leading-6 text-foreground-500">{shot.desc}</p>
                </figcaption>
              </figure>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}